/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
    PageableToJSONTyped,
} from './Pageable';
import type { TaskResponse } from './TaskResponse';
import {
    TaskResponseFromJSON,
    TaskResponseFromJSONTyped,
    TaskResponseToJSON,
    TaskResponseToJSONTyped,
} from './TaskResponse';

/**
 * 
 * @export
 * @interface TaskResponsePaginated
 */
export interface TaskResponsePaginated {
    /**
     * 
     * @type {Array<TaskResponse>}
     * @memberof TaskResponsePaginated
     */
    tasks?: Array<TaskResponse>;
    /**
     * 
     * @type {Pageable}
     * @memberof TaskResponsePaginated
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof TaskResponsePaginated
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the TaskResponsePaginated interface.
 */
export function instanceOfTaskResponsePaginated(value: object): value is TaskResponsePaginated {
    return true;
}

export function TaskResponsePaginatedFromJSON(json: any): TaskResponsePaginated {
    return TaskResponsePaginatedFromJSONTyped(json, false);
}

export function TaskResponsePaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskResponsePaginated {
    if (json == null) {
        return json;
    }
    return {
        
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(TaskResponseFromJSON)),
        'pageable': json['pageable'] == null ? undefined : PageableFromJSON(json['pageable']),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function TaskResponsePaginatedToJSON(json: any): TaskResponsePaginated {
    return TaskResponsePaginatedToJSONTyped(json, false);
}

export function TaskResponsePaginatedToJSONTyped(value?: TaskResponsePaginated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(TaskResponseToJSON)),
        'pageable': PageableToJSON(value['pageable']),
        'totalCount': value['totalCount'],
    };
}

